import { API } from "./index";

const getPriceChartApi = (body) => API.post("/priceChart/getPriceChart", body);

const getLotListApi = (body) => API.post("/priceChart/getLotList", body);

const getLotCodeInsertApi = (body) => API.post("/priceChart/getLotCode", body);

const insertPriceChartComponentApi = (body) => API.post("/priceChart/insert", body);

const deletePriceChartComponentApi = (body) => API.post("/priceChart/deleteComponent", body);

const updatePriceChartComponentApi = (body) => API.post("/priceChart/updatePriceChart", body);

const suggetionDataApi = (body) => API.post("priceChart/suggectionData", body);

const bulkDataUpdateApi= (body)=>API.post("priceChart/excelUpdate", body)

export {
  API,
  getPriceChartApi,
  getLotListApi,
  getLotCodeInsertApi,
  insertPriceChartComponentApi,
  deletePriceChartComponentApi,
  updatePriceChartComponentApi,
  suggetionDataApi,
  bulkDataUpdateApi
};
